import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    copiedLabel: String
  }

  async copy() {
    this.element.disabled = true

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        credentials: "same-origin"
      })
      const payload = await response.json()

      if (!response.ok) throw new Error(payload.error)

      await this.copyText(payload.url)
      this.showCopiedLabel()
    } catch (error) {
      window.alert(error.message || "Odkaz se nepodařilo zkopírovat.")
    } finally {
      this.element.disabled = false
    }
  }

  async copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text)
      return
    }

    const input = document.createElement("textarea")
    input.value = text
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.append(input)
    input.select()
    document.execCommand("copy")
    input.remove()
  }

  showCopiedLabel() {
    const originalTitle = this.element.title
    const originalAriaLabel = this.element.getAttribute("aria-label")

    this.element.title = this.copiedLabelValue
    this.element.setAttribute("aria-label", this.copiedLabelValue)

    const notice = document.createElement("div")
    notice.className = "app-copy-notice"
    notice.setAttribute("role", "status")
    notice.textContent = this.copiedLabelValue
    document.body.append(notice)

    window.setTimeout(() => {
      this.element.title = originalTitle
      this.element.setAttribute("aria-label", originalAriaLabel)
      notice.remove()
    }, 2000)
  }
}
